module.exports = __webpack_public_path__ + "img/reserved_4.1525627a.jpg";